import { render, staticRenderFns } from "./blacktitle.vue?vue&type=template&id=72c75fbd&scoped=true"
import script from "./blacktitle.vue?vue&type=script&lang=js"
export * from "./blacktitle.vue?vue&type=script&lang=js"
import style0 from "./blacktitle.vue?vue&type=style&index=0&id=72c75fbd&prod&lang=scss"
import style1 from "./blacktitle.vue?vue&type=style&index=1&id=72c75fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c75fbd",
  null
  
)

export default component.exports